import PropTypes from 'prop-types';
import React from 'react';
import Scrollspy from 'react-scrollspy';
import tw from 'tailwind.macro';
import Button from './button';

const PageNavigator = ({ items, buttonLink, buttonText, ...other }) => {
  console.log(typeof items);

  return (
    <div
      css={[
        tw`sticky top-0 py-5 bg-white`,
        `z-index: 49; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 -10px 15px rgba(0,0,0,0.25)`,
      ]}
    >
      <div
        className={`container ${
          buttonLink ? 'grid md:grid-cols-4 items-center' : ''
        }`}
        {...other}
      >
        <Scrollspy
          items={Object.keys(items)}
          currentClassName="current"
          offset={-60}
          css={tw`my-0 p-0`}
          className={`${buttonLink ? 'col-span-2 md:col-span-3' : ''}`}
        >
          {Object.keys(items).map((key, index) => (
            <li key={key} css={tw`inline-block my-0 mr-2 list-style-none`}>
              <a
                href={'#'.concat(key)}
                css={{ '.current &': tw`text-maroon border-maroon border-b-2` }}
              >
                {items[key]}
              </a>
              {index < Object.keys(items).length - 1 && (
                <span className="separator" css={tw`ml-2`}>
                  &middot;
                </span>
              )}
            </li>
          ))}
        </Scrollspy>
        <div className={!buttonLink ? 'hidden' : 'hidden md:block text-right'}>
          <Button to={buttonLink}>{buttonText}</Button>
        </div>
      </div>
    </div>
  );
};

PageNavigator.propTypes = {
  items: PropTypes.object.isRequired,
};

export default PageNavigator;
